/* Oct 25, 2026: on phones and desktop, show the header language choices as tap buttons inside the
   currency/language menu (the native drop-down list ran off the screen on phones). */
(function () {
  /* Oct 25, 2026: show language names without the country in brackets, e.g. "Português (Portugal)" -> "Português".
     Applies to every language selector on every page (header, footer, menu drawer). */
  function cleanName(t) { return t.replace(/\s*\([^)]*\)\s*$/, '').trim(); }
  function cleanSelects() {
    document.querySelectorAll('select.localization-form__select option').forEach(function (o) {
      var c = cleanName(o.textContent);
      if (c !== o.textContent) o.textContent = c;
    });
  }
  function build() {
    cleanSelects();
    document.querySelectorAll('#header-component .dropdown-localization .language-selector').forEach(function (wrap) {
      if (wrap.querySelector('.mloc-lang-chips')) return;
      var select = wrap.querySelector('select.localization-form__select');
      if (!select) return;
      var box = document.createElement('div');
      box.className = 'mloc-lang-chips';
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', select.getAttribute('aria-label') || 'Language');
      Array.prototype.forEach.call(select.options, function (opt) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mloc-lang-chip';
        b.textContent = cleanName(opt.textContent);
        b.setAttribute('lang', opt.value);
        if (opt.selected) b.setAttribute('aria-pressed', 'true');
        b.addEventListener('click', function () {
          if (select.value === opt.value) return;
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        box.appendChild(b);
      });
      wrap.classList.add('mloc-has-chips');
      wrap.appendChild(box);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
